import { behaviors } from "common/entities/locales/behaviors";
import { messages } from "common/entities/locales/messages";

export const translate = (key: string): string =>
  behaviors(key) || messages(key) || key;
